import { createAction, props } from '@ngrx/store';
// import { Doctor } from 'src/models/module-wise/user/patient';

// TODO: Add Interface

export const paginateDoctors = createAction(
  '[ DOCTOR ] Paginating'
);

export const loadDoctors = createAction(
  '[ DOCTOR ] Load Doctor',
  props<{ payload: any[], totalDocuments: number }>()
);

export const editDoctor = createAction(
  '[ DOCTOR ] Edit Doctor',
  props<{ payload: any | { status: string, _id: string } }>()
);

export const removeDoctors = createAction(
  '[ DOCTOR ] Delete Doctor',
  props<{ payload: string[] }>()
);

export const removeAllDoctors = createAction(
  '[ DOCTOR ] Remove All Doctor'
);
